"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKDataGridLegacyExampleCodeSegments = exports.GKDataGridLegacyExample = void 0;
var React = __importStar(require("react"));
var gds_ux_components_1 = require("@granular/gds-ux-components");
var components_1 = require("../../components");
// <copy>
var GKDataGridLegacyExample = function () {
    var _a = React.useState(false), filterState = _a[0], setFilterState = _a[1];
    // Basic numerical sort but undefined always sorts to the bottom.
    var catSort = function (a, b, desc) {
        if (a === undefined) {
            return desc ? -1 : 1;
        }
        else if (b === undefined) {
            return desc ? 1 : -1;
        }
        else {
            return a > b ? 1 : -1;
        }
    };
    // Case insensitive string search that finds occurances anywhere within the string.
    var nameFilter = function (filter, row) {
        return row[filter.id].toLowerCase().includes(filter.value.toLowerCase());
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(gds_ux_components_1.GKCheckbox, { id: "gdg-filter", label: "Display Filters", checked: filterState, onChange: function () { return setFilterState(!filterState); } }),
        React.createElement(components_1.GKDataGridLegacy, { gridClassName: "-highlight", filterable: filterState, columns: {
                xs: [
                    {
                        Header: "Name",
                        accessor: "name",
                    },
                    {
                        Header: "Age",
                        accessor: "age",
                    },
                ],
                lg: [
                    {
                        Header: "First Name",
                        accessor: "name",
                        className: "font-weight-bold",
                        filterMethod: nameFilter,
                    },
                    {
                        Header: "Age",
                        accessor: "age",
                        sortable: false,
                    },
                    {
                        Header: "# of Cats",
                        accessor: "cats",
                        id: "cats",
                        sortMethod: catSort,
                    },
                ],
            }, data: [
                { name: "Bob", age: 37, cats: 3 },
                { name: "Carl", age: 45, cats: 1 },
                { name: "Phyllis", age: 52, cats: 42 },
                { name: "Khaleesi", age: 4 }, // Undefined 'cat' handled gracefully
            ] })));
};
exports.GKDataGridLegacyExample = GKDataGridLegacyExample;
// </copy>
// AUTOGENERATED:
/* eslint-disable prettier/prettier */
exports.GKDataGridLegacyExampleCodeSegments = ["export const GKDataGridLegacyExample: React.FC = () => {\n  const [filterState, setFilterState] = React.useState(false);\n  // Basic numerical sort but undefined always sorts to the bottom.\n  const catSort = (a: any, b: any, desc: boolean): 1 | -1 => {\n    if (a === undefined) {\n      return desc ? -1 : 1;\n    } else if (b === undefined) {\n      return desc ? 1 : -1;\n    } else {\n      return a > b ? 1 : -1;\n    }\n  };\n  // Case insensitive string search that finds occurances anywhere within the string.\n  const nameFilter = (filter: Filter, row: any): boolean => {\n    return row[filter.id].toLowerCase().includes(filter.value.toLowerCase());\n  };\n  return (\n    <>\n      <GKCheckbox\n        id=\"gdg-filter\"\n        label=\"Display Filters\"\n        checked={filterState}\n        onChange={(): void => setFilterState(!filterState)}\n      />\n      <GKDataGridLegacy\n        gridClassName=\"-highlight\"\n        filterable={filterState}\n        columns={{\n          xs: [\n            {\n              Header: \"Name\",\n              accessor: \"name\",\n            },\n            {\n              Header: \"Age\",\n              accessor: \"age\",\n            },\n          ],\n          lg: [\n            {\n              Header: \"First Name\",\n              accessor: \"name\",\n              className: \"font-weight-bold\",\n              filterMethod: nameFilter,\n            },\n            {\n              Header: \"Age\",\n              accessor: \"age\",\n              sortable: false,\n            },\n            {\n              Header: \"# of Cats\",\n              accessor: \"cats\",\n              id: \"cats\",\n              sortMethod: catSort,\n            },\n          ],\n        }}\n        data={[\n          { name: \"Bob\", age: 37, cats: 3 },\n          { name: \"Carl\", age: 45, cats: 1 },\n          { name: \"Phyllis\", age: 52, cats: 42 },\n          { name: \"Khaleesi\", age: 4 }, // Undefined 'cat' handled gracefully\n        ]}\n      />\n    </>\n  );\n};"];
/* eslint-enable prettier/prettier */
